<template>
  <v-dialog v-model="modal" persistent width="1000px">
    <v-card>
      <v-card-title> Changement de mot de passe</v-card-title>
      <v-card-text>
        <v-form ref="form" :readonly="working">
          <v-container fluid>
            <v-row dense>
              <v-col cols="12">
                <p class="accent-block">Saisissez votre nouveau mot de passe.</p>
              </v-col>
              <v-col cols="12">
                <a-motpasse-field
                  dense
                  label="Ancien mot de passe"
                  v-model="ancien"
                  filled
                  :rules="[requiredRule(), serverRule('ancien')]"
                  counter
                  data-testid="ancien-mot-de-passe"
                />
              </v-col>
              <v-col cols="12">
                <a-motpasse-field
                  dense
                  label="Mot de passe"
                  v-model="motPasse"
                  filled
                  :rules="[requiredRule(), serverRule('motPasse')]"
                  hint="Au moins 10 caractères."
                  counter
                  data-testid="mot-de-passe"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn data-testid="valider-changer-mot-de-passe" color="primary" @click="valider" :loading="working"> Valider </v-btn>
        <v-btn data-testid="annuler-changer-mot-de-passe" @click="ferme" :disabled="working"> Annuler </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import makeRules from "@/mixins/makeRules";
import { VuexSnackbar } from "@/mixins/makeVuexSnackbar";
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import { principalService } from "@/services";

export default {
  mixins: [
    VuexSnackbar,
    makeRules({ inject: false }),
    makeRemoteWorker({ provide: false }),
  ],

  data() {
    return {
      working: false,
      modal: false,
      motPasse: null,
      ancien: null,
    };
  },

  methods: {
    ferme() {
      this.modal = false;
    },

    ouvre(callback) {
      this.motPasse = null;
      this.ancien = null;
      this.callback = callback;
      this.modal = true;
      this.$nextTick(() => {
        this.clearValidation();
        this.$refs.form.resetValidation();
      });
    },

    valider() {
      const callback = this.callback;
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return principalService.modifierMotPasse(this.ancien, this.motPasse);
        },
        callback(response) {
          this.modal = false;
          callback(response);
        },
        successText: "Votre mot de passe a été changé.",
        errorText: "Erreur durant le changement de mot de passe.",
      });
    },
  },
};
</script>
